import { cn } from "@/lib/utils";

interface CaretProps {
  /** Sobrescreve a cor/estilo do cursor. Padrão: `bg-primary`. */
  className?: string;
}

/** Cursor piscante exibido ao final do trecho que está sendo digitado. */
export function Caret({ className }: Readonly<CaretProps>) {
  return (
    <span
      className={cn(
        "-mb-[2px] ml-0.5 inline-block h-[1.05em] w-[2px] animate-pulse rounded-full bg-primary",
        className,
      )}
      aria-hidden
    />
  );
}
